var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import { css } from 'styled-components';
import { CheckboxStylePropertiesBySize } from '../types/CheckboxStylePropertiesBySize';
export var getCheckboxStylesBySize = function (size) {
    var _a = CheckboxStylePropertiesBySize[size], height = _a.height, width = _a.width, iconWidth = _a.iconWidth, marginTop = _a.marginTop;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    width: ", ";\n    margin-top: ", ";\n\n    & > * {\n      width: ", ";\n    }\n  "], ["\n    height: ", ";\n    width: ", ";\n    margin-top: ", ";\n\n    & > * {\n      width: ", ";\n    }\n  "])), height, width, marginTop, iconWidth);
};
var templateObject_1;
//# sourceMappingURL=getCheckboxStylesBySize.js.map